import { useEffect, useState } from "react";
import axios from "axios";

function KatalogEdit({ id, onBack }) {
  const [form, setForm] = useState({ naslov: "", opis: "" });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadItem = async () => {
      try {
        const res = await axios.get(`http://localhost:5000/api/katalog/${id}`);
        setForm({ naslov: res.data.Naslov, opis: res.data.opis });
      } catch (err) {
        console.error(err);
        alert("Proizvod nije pronađen");
        onBack();
      } finally {
        setLoading(false);
      }
    };
    loadItem();
  }, [id, onBack]);

  if (loading) return <p>Učitavanje...</p>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("naslov", form.naslov);
    data.append("opis", form.opis);
    if (image) data.append("image", image);

    await axios.put(`http://localhost:5000/api/katalog/${id}`, data);
    alert("Proizvod ažuriran");
    onBack();
  };

  return (
    <div className="container py-5 d-flex justify-content-center">
      <form
        onSubmit={handleSubmit}
        className="p-4 shadow-lg rounded-4 bg-white"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <h3 className="text-center mb-4 fw-bold">Izmeni stavku</h3>

        <div className="mb-3">
          <label className="form-label fw-semibold">Naslov</label>
          <input
            type="text"
            className="form-control form-control-lg"
            value={form.naslov}
            onChange={e => setForm({ ...form, naslov: e.target.value })}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Opis</label>
          <textarea
            className="form-control"
            rows="4"
            value={form.opis}
            onChange={e => setForm({ ...form, opis: e.target.value })}
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">Promeni sliku</label>
          <input
            type="file"
            className="form-control"
            onChange={e => setImage(e.target.files[0])}
          />
        </div>

        <div className="d-flex gap-2">
          <button type="submit" className="btn btn-dark w-100 fw-semibold">
            Sačuvaj
          </button>

          <button
            type="button"
            className="btn btn-outline-secondary w-100"
            onClick={onBack}
          >
            Nazad
          </button>
        </div>
      </form>
    </div>
  );
}

export default KatalogEdit;